import { z } from 'zod';
import {
  BACKEND_I18N_CODES,
  type BackendI18nCode,
} from '~/generated/backend-i18n-codes';

export type TemplateParameterV1 = Extract<BackendI18nCode, `@${string}`>;

const paramCode = BACKEND_I18N_CODES.filter(
  (code): code is TemplateParameterV1 => code.startsWith('@'),
);

export const templateParameterV1Schema = z.enum(paramCode);

export function isDateTimeParam(param: string | undefined): boolean {
  return param?.endsWith('DateTime') ?? false;
}
